import { useParams } from 'react-router-dom'

import { CertificateViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FileViewer as Viewer } from 'modules/trainings/components/Files/FileViewer'

export default function Certificates() {
  const { navigation } = useNavigation()
  const { id, trainingMembershipId, employeeId, trainingMembershipFileId } = useParams()
  const { data, loading } = useQuery(CertificateViewerDocument, {
    variables: {
      trainingMembershipId: Number(trainingMembershipId),
    },
  })

  if (loading) return null

  const files =
    data?.trainings.trainingMembershipFilesConnection.nodes.map((file) => ({
      contentType: file.contentType,
      fileUrl: file.url,
      filename: file.filename,
      id: file.id,
      title: file.filename,
      type: 'membership' as const,
      url: file.url,
    })) ?? []

  return (
    <Viewer
      file={files?.find((f) => f.id === Number(trainingMembershipFileId))}
      files={files}
      urlBackTo={navigation.trainings.list.details_revamp.view.participants.employees.fullPath({
        id: Number(id),
        employeeId: Number(employeeId),
      })}
      goNextFile={(f) =>
        navigation.trainings.list.details_revamp.view.participants.employees.previewCertificate.fullPath(
          {
            id: Number(id),
            employeeId: Number(employeeId),
            trainingMembershipId: String(trainingMembershipId),
            trainingMembershipFileId: f.id,
          }
        )
      }
      goPrevFile={(f) =>
        navigation.trainings.list.details_revamp.view.participants.employees.previewCertificate.fullPath(
          {
            id: Number(id),
            employeeId: Number(employeeId),
            trainingMembershipId: String(trainingMembershipId),
            trainingMembershipFileId: f.id,
          }
        )
      }
    />
  )
}
